import {
  ACTUAL_PLAN_MONTHLY_SPEND,
  ACTUAL_PLAN_MONTHLY_SPEND_WITHOUT_LOCAL,
  ACTUAL_PLAN_WEEKLY_SPEND,
  ACTUAL_PLAN_WEEKLY_SPEND_WITHOUT_LOCAL,
} from '../constant';

// This function returns the appropriate component based on the isWeekly flag and spendToggleState
export const actualSpendDownloadComponent = (isWeekly, spendToggleState) => {
  const queries = isWeekly
    ? [ACTUAL_PLAN_WEEKLY_SPEND, ACTUAL_PLAN_WEEKLY_SPEND_WITHOUT_LOCAL]
    : [ACTUAL_PLAN_MONTHLY_SPEND, ACTUAL_PLAN_MONTHLY_SPEND_WITHOUT_LOCAL];
  // Ensure spendToggleState is boolean and index is within bounds
  const index = spendToggleState ? 1 : 0;
  return queries?.[index] || queries?.[0];
};
